import angular from 'angular';
import IntTypeValidationService from './intTypeValidation.service';

let intTypeValidationModule = angular.module('intTypeValidation', []).service('intTypeValidationService', IntTypeValidationService);

export default intTypeValidationModule;



// WEBPACK FOOTER //
// ./app/common/intTypeValidation/intTypeValidation.js